import { Component, Input, OnInit } from '@angular/core';
import { CourseType, LearnModuleType } from '@cna/projects/ak-jura/shared/interfaces';
import { filterNil } from '@cna/shared/helper';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { LearningModuleDocumentInfo } from '../../../../../../shared/interfaces/src/lib/learning-module-document-info';
import {
    selectCustomersCourseParticipation,
    selectCustomersCourseParticipationModules,
    selectMayAccessLearning,
} from '../../../../../../../../../apps/ak-jura/frontends/my-ak-jura/src/app/+state/course_participation/selectors';

import { CertificateService } from '../../../../learning/src/lib/services/certificate.service';

@Component({
    selector: 'cna-learnstate-accordion',
    templateUrl: './learnstate-accordion.component.html',
    styleUrls: ['./learnstate-accordion.component.scss'],
})
export class LearnstateAccordionComponent implements OnInit {
    @Input() selectedCategory: string;

    totalProgress$: Observable<number>;
    totalTimeSpent$: Observable<number>;

    courseType$: Observable<CourseType> = this.store
        .select(selectCustomersCourseParticipation)
        .pipe(map(course => course?.bookedCourse.type));

    courseTypeDescription$ = this.courseType$.pipe(
        map(courseType => {
            switch (courseType) {
                case CourseType.EducationCourse:
                    return 'Lehrgang';
                case CourseType.TrainingCourse:
                    return 'Fortbildung';
                default:
                    return 'Kurs';
            }
        })
    );

    moduleInfos$: Observable<(LearningModuleDocumentInfo & { type: LearnModuleType, name: string })[]> = this.store.select(
        selectCustomersCourseParticipationModules
    ).pipe(
        filterNil(),
        map((moduleInfos) => {
            const moduleTypeOrder = [LearnModuleType.Module, LearnModuleType.Repetitorium]
            return [...moduleInfos].sort((m1, m2) => {
                if(m1.type !== m2.type) {
                    return moduleTypeOrder.indexOf(m1.type) - moduleTypeOrder.indexOf(m2.type);
                }
                return (m1.sequentialNumber ?? 0) - (m2.sequentialNumber ?? 0)
            })
        })
    );

    mayAccessLearning$ = this.store.select(selectMayAccessLearning());

    CourseType = CourseType;

    constructor(
        private store: Store,
        private certificateService: CertificateService
    ) {}

    ngOnInit(): void {
        this.totalTimeSpent$ = this.moduleInfos$.pipe(
            map(val => val.map(vala => vala.totalTimeRead)),
            map(learnTimes =>
                learnTimes && learnTimes.length > 0
                    ? learnTimes.reduce((acc, curr) => acc + curr)
                    : 0
            )
        );

        this.totalProgress$ = this.moduleInfos$.pipe(
            map(val => val.map(vala => vala.percentageRead)),
            map(progresses =>
                progresses && progresses.length > 0
                    ? progresses.reduce((acc, curr) => acc * curr)
                    : 0
            )
        );
    }

    async downloadLearnControlPdf(
        moduleInfo: LearningModuleDocumentInfo,
        courseType: CourseType
    ) {
        return this.certificateService.downloadLearnControlPdf(moduleInfo, courseType)
    }

    protected readonly LearnModuleType = LearnModuleType;
}
